import { render } from "./aio-login-dashboard.vue?vue&type=template&id=34b3d340"
import script from "./aio-login-dashboard.vue?vue&type=script&lang=js"
export * from "./aio-login-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__